import { Injectable, NgZone } from '@angular/core';
import {  MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { MensajeComponent } from 'src/app/components/shared/mensaje/mensaje.component';

@Injectable({
  providedIn: "root",
})
export class NotificationService {
  // DIALOG
  matDialog: MatDialog = null;

  constructor(
    private dialog: MatDialog,
    public snackBar: MatSnackBar,
    private zone: NgZone
  ) { }

  // NOTIFICATIONSERVICE
  showSuccess(message: string, duration = 3000) {
    return this.snackBar.open(message, "", {
      panelClass: ["alert-green"],
      duration,
    });
  }

  showInfo(message: string) {
    return this.snackBar.open(message, "", {
      panelClass: ["alert-blue"],
      duration: 4000,
    });
  }

  showError(message: string, duration = 3000) {
    // this.zone.run(() => {
      this.snackBar.open(message, "", {
        panelClass: ["alert-red"],
        duration: 5000,
      });
    // });
  }

  showErrortop(message: string) {
    this.zone.run(() => {
      this.snackBar.open(message, "Cerrar", {
        panelClass: ["alert-red"], verticalPosition: 'top',
        duration: 5000,
      });
    });
  }

  showErrorWithTime(message: string, _time: number) {
    return this.snackBar.open(message, "", {
      panelClass: ["alert-red"],
      duration: 3000,
    });
  }

  // Funcion para mostrar mensajes 27/10/2022 AHV.
  muestraMensaje(mensaje: string) {
    const dialogRef = this.dialog.open(MensajeComponent, {
      width: "500px",
      data: {
        titulo: mensaje,
        btnCancel: "Aceptar",
        icon: "error_outline",
      },
    });
    dialogRef.afterClosed().subscribe((_result) => {
      // This is intentional
    });
  }
}
